import {Component, ElementRef, HostListener, inject, ViewChild} from '@angular/core';
import {NavHeaderComponent} from "../nav-header/nav-header.component";
import {TeamCircleComponent} from "./team-circle/team-circle.component";
import {StatisticsComponent} from "../statistics/statistics.component";
import {ContactUsComponent} from "../contact-us/contact-us.component";
import {FooterComponent} from "../footer/footer.component";
import {DotsLoaderComponent} from "../../../../core/helper-components/dots-loader/dots-loader.component";
import {TeamStore} from "./store/team-store";

@Component({
  selector: 'app-team',
  templateUrl: './team.component.html',
    imports: [
        NavHeaderComponent,
        TeamCircleComponent,
        StatisticsComponent,
        ContactUsComponent,
        FooterComponent,
        DotsLoaderComponent
    ],
  standalone: true,
  styleUrls: ['./team.component.scss'],
  providers: [TeamStore]
})
export class TeamComponent {

  @ViewChild('element') element!: ElementRef;
  isVisible = false;

  readonly #store: any = inject(TeamStore);
  protected readonly isLoading = this.#store.isLoading;

  @HostListener('window:scroll', ['$event'])
  checkScroll() {
    const titleContainerOffset = this.element?.nativeElement?.offsetTop;
    const scrollPosition = window.scrollY + window.innerHeight;
    scrollPosition > titleContainerOffset ? this.isVisible = true : this.isVisible = false;
  }

}
